import React from "react";
import { useNavigate } from "react-router-dom";

import image from "../../assets/images/404.png";
import "./PageNotFound.scss";

const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="app-not-found">
      <div className="image">
        <img src={image} alt="404" />
      </div>
      <h1>Page Not Found.</h1>
      <p>
        The server encountered something unexpected that didn't allow it to
        complete the request.
        <br />
        We apologize you can go to the main page
      </p>
      <button className="btn-main btn-404" onClick={() => navigate("/")}>
        Go To Home Page
      </button>
    </div>
  );
};

export default PageNotFound;
